module.exports = __webpack_public_path__ + "static/img/code.3735e8f6.png";